import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../PaymentDetailPage.module.css";
import OrderCodeInput from "./OrderCodeInput";

export default function AddRow({
  addType, setAddType, addDraft, setAddField, addSaving, onAdd,
  clientOrders, ordersByCode, currencies, accounts,
}) {
  const navigate = useNavigate();

  const orderPreview = (() => {
    const code = addDraft.orderCode.trim().toLowerCase();
    if (!code) return null;
    return ordersByCode.get(code) || null;
  })();

  return (
    <tr className="border-t bg-slate-50">
      <td className="border p-1">
        <input
          type="date"
          className="w-full rounded border px-2 py-1 text-xs"
          value={addDraft.date}
          onChange={(e) => setAddField("date", e.target.value)}
        />
      </td>
      <td className="border p-1">
        <select
          className="w-full rounded border px-2 py-1 text-xs"
          value={addType}
          onChange={(e) => setAddType(e.target.value)}
        >
          <option value="allocation">Платёж фабрике</option>
          <option value="commission">Комиссия</option>
        </select>
      </td>
      
      <td className="border p-1">
        <OrderCodeInput
          id="add-order-suggestions"
          orders={clientOrders}
          value={addDraft.orderCode}
          onChange={(v) => setAddField("orderCode", v)}
          placeholder="Код заказа"
          className="w-full rounded border px-2 py-1 text-xs"
        />
      </td>


      <td className="border p-1 text-xs">
        {addType === "commission" ? (
          <select
            className="w-full rounded border px-1 py-1 text-xs"
            value={addDraft.account}
            onChange={(e) => setAddField("account", e.target.value)}
          >
            <option value="">— счёт —</option>
            {accounts.map((acc) => (
              <option key={acc.id} value={acc.id}>
                {acc.name}{acc.currency ? ` (${acc.currency})` : ""}
              </option>
            ))}
          </select>
        ) : orderPreview ? (
          <button
            type="button"
            onClick={() => navigate(`/orders/${orderPreview.id}/finances`)}
            className="text-left text-blue-700 hover:underline"
          >
            Счёт заказа {addDraft.orderCode.trim()}
          </button>
        ) : (
          <span className="text-slate-400">—</span>
        )}
      </td>
      <td className="border p-1">
        <div className="flex gap-1">
          <input
            type="number"
            className={`flex-1 rounded border px-2 py-1 text-xs ${styles.noNumberSpinner}`}
            placeholder="Сумма"
            onWheel={(e) => e.currentTarget.blur()}
            value={addDraft.amount}
            onChange={(e) => setAddField("amount", e.target.value)}
            min="0.01"
            step="0.01"
          />
          <select
            className="w-24 rounded border px-1 py-1 text-xs"
            value={addDraft.currency}
            onChange={(e) => setAddField("currency", e.target.value)}
          >
            <option value="">—</option>
            {currencies.map((c) => (
              <option key={c.id} value={c.id}>
                {c.symbol} {c.code}
              </option>
            ))}
          </select>
        </div>
      </td>
      <td className="border p-1 text-xs text-slate-400">—</td>
      <td className="border p-1">
        <select
          className="w-full rounded border px-2 py-1 text-xs"
          value={addDraft.payment_status}
          onChange={(e) => setAddField("payment_status", e.target.value)}
        >
          <option value="PENDING">Ожидает</option>
          <option value="PAID">Оплачен</option>
        </select>
      </td>
      <td className="border p-1">
        <input
          className="w-full rounded border px-2 py-1 text-xs"
          placeholder="Коммент."
          value={addDraft.comment}
          onChange={(e) => setAddField("comment", e.target.value)}
        />
      </td>
      <td className="border p-1">
        <input
          className="w-full rounded border px-2 py-1 text-xs"
          placeholder="Через"
          value={addDraft.payment_agent}
          onChange={(e) => setAddField("payment_agent", e.target.value)}
        />
      </td>
      <td className="border p-1 text-xs text-slate-400">—</td>
      <td className="border p-1">
        <button
          type="button"
          onClick={onAdd}
          disabled={addSaving}
          className="rounded bg-blue-600 px-3 py-1 text-xs font-semibold text-white hover:bg-blue-700 disabled:opacity-50"
        >
          {addSaving ? "..." : "Добавить"}
        </button>
      </td>
    </tr>
  );
}